.profileDetail,
.profileDetailIcon {
  position: absolute;
  top: var(--spacing-16);
  left: var(--spacing-24);
  z-index: 5;
  pointer-events: all;
  display: flex;
  align-items: center;
  gap: var(--spacing-16);
}

.profileDetail {
  bottom: var(--spacing-16);
  width: 411px;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--sparky-brand-white);
  border-radius: var(--border-radius-02);
  border: 1px solid #d0d0d0;
  padding: var(--spacing-24);
  box-shadow: var(--sparky-elevation-3);

  .profileDetailHeader {
    display: flex;
    align-items: center;
    height: 44px;
    justify-content: flex-start;
    gap: var(--spacing-16);
  }

  .closeProfileDetailIcon {
    position: absolute;
    top: var(--spacing-12);
    right: -24px;
  }

  .profileDetailContent {
    display: flex;
    gap: var(--spacing-16);
    flex-direction: column;
    width: 100%;
    height: calc(100% - 120px);

    .profilePinList {
      display: flex;
      gap: var(--spacing-04);
      flex-direction: column;
      width: 100%;
      overflow: auto;

      .profilePin {
        display: flex;
        gap: var(--spacing-04);
        flex-direction: column;

        .pinDetailsWrapper {
          border-radius: var(--border-radius-02);
          overflow: hidden;
        }

        .modifyPinDetail {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-08);
          padding: var(--spacing-16);
          background-color: var(--sparky-grey-100);

          .deletePinButtonContent {
            background-color: unset;
          }

          .deletePinButton {
            width: fit-content;
          }
        }
      }

      .addPinPanel {
        display: flex;
        flex-direction: column;
        padding: var(--spacing-16);
        gap: var(--spacing-08);
        background-color: var(--sparky-grey-100);

        .addPinButtonsWrapper {
          display: flex;
          justify-content: flex-end;
          gap: var(--spacing-08);
        }
      }
    }

    .addAnotherPin {
      width: fit-content;
    }
  }

  .profileDetailFooter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    gap: var(--spacing-08);
  }

  .cancelButton {
    margin-left: auto;
  }
}
